export default __webpack_public_path__ + "static/media/favicon.317d296a.png";